import { del } from "../methods";
function deleteRefreshTokenAll(headers = {}) {
  return del({
    url: "backend/auth/refresh_token/all",
    headers
  });
}
export {
  deleteRefreshTokenAll
};
